export default {
  ApiErrors: {
    generic: 'Ocurrió un error. Por favor, recargue la página y contáctenos si el problema persiste.',
    'Email already exists': 'Correo electrónico no disponible',
    'This field is required.': 'Este campo es obligatorio',
    'First_name must be filled': 'El nombre debe ser completado',
    'Password length must be over 8 characters': 'La longitud de la contraseña debe ser de más de 8 caracteres',
    'Unable to login with the provided credentials': 'No se puede iniciar sesión con las credenciales proporcionadas',
    'godson is already a customer': 'Este correo electrónico ya pertenece a un cliente',
    'godson is in referral process': 'Este correo electrónico ya está en proceso de recomendación',
    'Enter a valid email address': 'Esta no es una dirección de correo electrónico válida',
    'Email already in db': 'Correo electrónico no disponible',
    'Not an email': 'Correo electrónico no válido',
    'Reward is soldout': 'Esta recompensa está agotada',
    'Reward can only be claimed once': 'Ya has reclamado esta recompensa',
    'Reward is no longer valid': 'Esta recompensa ya no es válida',
    'Not enough points': 'No tienes suficientes puntos',
    'Account already in use': 'Esta cuenta ya está siendo utilizada por otro usuario',
    'This instagram account does not exist on Instagram': 'Esta cuenta de Instagram no existe',
    'social error': "Por favor, ingrese su cuenta {'@'}mi_cuenta",
    'required field': 'Por favor, complete este campo',
    'value error': 'El valor ingresado no es correcto',
    'You already applied a discount code': 'Ya has aplicado un código de descuento'
  },
  Error: {
    generic: 'Ocurrió un error, por favor recargue la página.',
    link: 'Recargar la página',
    title: 'Loyoly - ¡Ups! Error',
    blacklistMessage1: 'No eres elegible para el programa de fidelidad.',
    blacklistMessage2: 'Contacta al equipo de soporte si crees que esto es un error.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'Por favor, introduce una dirección de correo electrónico válida',
      emailEmpty: 'Por favor, introduce tu dirección de correo electrónico'
    }
  },
  InApp: {
    message: 'Para una experiencia óptima, utilice su navegador predeterminado'
  },
  Phone: {
    countrySelector: {
      placeholder: 'Código del país',
      error: 'Elija un país',
      searchPlaceholder: 'Seleccione un país'
    },
    phoneInput: {
      placeholder: 'Número de teléfono',
      example: 'Ejemplo:'
    },
    error: {
      invalid: 'Por favor, ingrese un número de teléfono válido'
    }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'Conectar a mi cuenta de Instagram',
      subtitle: 'Cómo funciona',
      description:
        'Por favor, ingrese su cuenta de Instagram y asegúrese de que sea pública antes de completar las misiones.',
      form: {
        username: 'Cuenta de Instagram',
        usernameExample: "{'@'}johndoe"
      },
      errors: {
        usernameEmpty: 'Por favor, ingrese el nombre de su cuenta',
        usernameNotFound: 'Por favor, ingrese un nombre de cuenta válido'
      },
      button: 'Validar'
    },
    ModalSearching: {
      title: 'Estamos buscando su cuenta'
    },
    ModalLinked: {
      title: 'Conectar a mi cuenta de Instagram',
      private: {
        subtitle: 'No se puede conectar con su cuenta',
        description: {
          title: 'Su cuenta de Instagram es privada',
          text: 'Vaya, parece que su cuenta de Instagram es privada. Cámbiela a modo público para acceder a todas las misiones.'
        }
      },
      public: {
        subtitle: 'Conexión con su cuenta exitosa',
        description: {
          title: 'Felicitaciones',
          text: 'Ahora puede realizar las misiones.'
        }
      },
      buttons: {
        edit: 'Editar mi cuenta',
        retry: 'Reintentar',
        goback: 'Volver a la página',
        gotoChallenge: 'Ir a la misión'
      }
    },
    ModalNotFound: {
      title: 'Conectar a mi cuenta de Instagram',
      subtitle: 'No se puede conectar con su cuenta',
      description: {
        title: 'Cuenta no encontrada',
        text: 'Le invitamos a cambiar de cuenta o hacer una solicitud al soporte.'
      },
      buttons: {
        change: 'Cambiar de cuenta',
        retry: 'Reintentar'
      }
    }
  },
  Modal: {
    Notifications: {
      title: 'Notificaciones por correo electrónico',
      information: {
        title: 'Información',
        text: 'Si no desea recibir recordatorios de misiones, noticias o recordatorios de recompensas, puede darse de baja desactivando las casillas a continuación:'
      },
      communication: {
        optinTransactional: 'Promocional: información sobre el programa, niveles VIP, recompensas.',
        optinMarketing: 'Información sobre compras y patrocinios.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'Cuenta pública',
        private: 'Cuenta privada',
        followers: '<span class="weglot-ignore">{n}</span> seguidor | <span class="weglot-ignore">{n}</span> seguidores'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> punto | <span class="weglot-ignore">{n}</span> puntos',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> punto | <span class="weglot-ignore">{value}</span> puntos',
  SectionHeader: {
    poweredBy: 'Desarrollado por'
  },
  SectionChallenges: {
    empty: 'No hay misiones disponibles en su programa de fidelidad',
    showAll: 'Mostrar todo',
    ModalMissionDetail: {
      description: 'Descripción',
      pointsToEarn: 'Puntos a ganar',
      howto: '¿Cómo funciona?',
      uploadMedia: 'Subir su medio',
      reviewApplication: 'Dejar una reseña',
      linkApplication: 'Descargar la aplicación',
      newsletterPartners:
        'Al hacer clic en "Validar la misión", acepta recibir ofertas comerciales de la empresa por medios electrónicos.',
      phonePartners: 'Acepto que mi número de teléfono sea utilizado para recibir ofertas por SMS.',
      clue: 'Pista',
      linkPage: 'Ver la página',
      instaMention: 'Etiquetar',
      tiktokMention: 'Etiquetar',
      instaHashtags: 'Hashtag(s) a usar',
      tiktokHashtags: 'Hashtag(s) a usar',
      linkToShare: 'Enlace a incluir en su historia',
      linkShare: 'Enlace para compartir',
      vouchertoShare: 'Código promocional para compartir',
      goToAccount: 'Ir a la cuenta',
      goToInsta: 'Ir a la cuenta',
      goToInstaPost: 'Ir a la publicación de Instagram',
      goToInstaReel: 'Ir al reel de Instagram',
      goToInstaIGTV: 'Ir al IGTV de Instagram',
      goToTweeterTweet: 'Ir al tweet',
      goToReview: 'Dejar una reseña',
      goToShop: 'Ir a la tienda',
      goToLink: 'Ir a la página',
      goToTypeform: 'Completar el formulario',
      goToWhatsapp: 'Unirse al grupo',
      submit: 'Validar la misión',
      missionPendingTitle: 'Misión en verificación',
      missionPendingExplain: 'Sus puntos serán acreditados pronto.',
      actionSurveyTextError: 'Por favor, seleccione una respuesta',
      actionEmailError: 'Su correo electrónico no es válido',
      actionInputError: 'Este campo no es válido',
      actionInputImageError: 'Por favor, suba su medio',
      handlingMedia: 'Procesando el medio',
      errorMediaHandle: 'Ocurrió un error al procesar su medio',
      imageInvalid: 'Ocurrió un error al procesar su medio',
      videoSize: 'El tamaño de su video debe ser menor a 100 MB.',
      errorInstaReel: 'La URL de su reel es incorrecta',
      'This url is not a valid google url': 'La URL de su reseña de Google es inválida',
      'This url is not a valid reel url': 'La URL de su reel es incorrecta',
      refusalReasonCondition: 'Incumplimiento de las condiciones',
      refusalReasonQuality: 'Calidad demasiado baja',
      refusalReasonContent: 'Contenido inapropiado',
      refusalReasonSound: 'Sonido inaudible',
      missionInvalidTitle: 'Misión invalidada',
      missionInvalidDescription: 'Puede volver a hacer la misión siguiendo cuidadosamente las reglas requeridas',
      missionInvalidReasons: 'Razón del rechazo:',
      condition: 'Condiciones',
      conditionExplanation: 'Tener más de',
      ineligible: 'No elegible',
      ineligibleExplanation:
        'Parece que no tiene la cantidad requerida de seguidores. Si tiene más seguidores, le invitamos a actualizar la información de su cuenta.',
      lastUpdate: 'Última actualización el',
      updateAccount: 'Actualizar mi cuenta',
      reviewLastPurchase: 'Dejar una reseña en la página del producto de su última compra',
      whenReviewValidated: 'Una vez que la reseña sea validada, su misión será automáticamente validada',
      pointsToEarnPhoto: 'Puntos adicionales por una foto',
      pointsToEarnVideo: 'Puntos adicionales por un video',
      howtoBirthdate: 'Ingrese su fecha de nacimiento',
      errorInvalidDate: 'Por favor, ingrese una fecha válida',
      inputMedia: 'Subir su medio',
      inputMediaLoaded: 'Su medio ha sido subido',
      placeholderAnswer: 'Escriba su respuesta aquí',
      misteryAnswer: '¿Cuál es la palabra misteriosa?',
      newsletterEmail: 'Confirme su dirección de correo electrónico',
      birthDate: 'Fecha de nacimiento',
      example: 'Ejemplo',
      goToChallenge: 'Ir a la misión'
    },
    ModalMissionImageRights: {
      imageRights:
        'Al marcar esta casilla, confirmo que soy el autor del contenido, acepto expresamente ceder los derechos de propiedad intelectual asociados y autorizo el uso de mi imagen por parte de la marca con fines comerciales según los términos y condiciones especificados en ',
      imageRightsLink: 'este acuerdo.',
      title:
        'Acuerdo de cesión de derechos de propiedad intelectual sobre el contenido y autorización para la explotación de mis atributos de personalidad.',
      content:
        'Acepto expresamente que la publicación del contenido realizado en el marco de mi misión (el “Contenido”):',
      bullet1:
        'implica la cesión, a favor de la marca, de la totalidad de los derechos de autor relacionados, para todo el mundo, durante toda la duración legal de protección del derecho de autor, de forma exclusiva y definitiva. Reconozco que esta cesión se realiza como contraprestación por los puntos obtenidos en el marco de mi misión, que constituyen una compensación justa. Esta cesión incluye el derecho de la marca a reproducir y representar el Contenido, total o parcialmente, en todos los soportes y por todos los medios, existentes o futuros, previsibles o imprevisibles, así como el derecho a traducir, modificar, adaptar, corregir y/o transformar el Contenido, por parte de la marca, sola o en colaboración con terceros. Me comprometo a que dicho Contenido no infrinja los derechos de terceros ni constituya una infracción, y garantizo a la marca en este sentido;',
      bullet2:
        'implica la autorización gratuita a la marca para fijar, reproducir, difundir y comunicar al público mis atributos de personalidad asociados al Contenido, en todos los soportes y por todos los medios conocidos o no, previsibles o imprevisibles, a través de cualquier medio, red y canal de difusión, con fines de explotación, información, comunicación, promoción y publicidad de los productos de la marca, por un período de 10 años, prorrogable en caso necesario mediante acuerdo mutuo.',
      end1: 'El presente acuerdo se rige por el derecho francés y será interpretado conforme a este.',
      end2: 'Cualquier disputa relativa a su validez, interpretación o ejecución será sometida a la jurisdicción exclusiva de los Tribunales de París, salvo disposición procesal en contrario.'
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        '<span class="weglot-ignore">{points}</span> punto a ganar por cada <span class="weglot-ignore">{amountToPoints}</span> gastados | <span class="weglot-ignore">{points}</span> puntos a ganar por cada <span class="weglot-ignore">{amountToPoints}</span> gastados',
      orderNumber: 'Pedido No.',
      orderDate: 'Fecha',
      orderAmount: 'Monto',
      orderRewardable: 'Recompensable',
      orderPoints: 'Puntos ganados',
      orderPaid: 'Validado',
      orderStatus: 'Estado',
      orderCancel: 'Reembolsado',
      orderRefund: 'Parcialmente reembolsado',
      orderWaiting: 'Pendiente'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'Ver las condiciones',
      seePrivacy: 'Ver la privacidad'
    }
  },
  SectionProfile: {
    socialNetworks: {
      instagram: 'Conectar a Instagram',
      tiktok: 'Conectar a TikTok'
    },
    notificationsByEmails: 'Notificaciones por correo electrónico',
    cgu: 'Términos y condiciones'
  },
  SectionAccountRewards: {
    empty: 'No hay más recompensas para canjear y no tienes recompensas pendientes de uso',
    copied: '¡Copiado!'
  },
  SectionRewards: {
    empty: 'No hay recompensas disponibles en su programa de fidelidad',
    showAll: 'Mostrar todo',
    Card: {
      channel_store: 'En la tienda',
      channel_online: 'Online',
      channel_both: 'Online y en la tienda'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'Mis recompensas',
    empty: 'Aún no tiene recompensas.',
    emptyTip: 'Puede completar misiones y canjear sus puntos ganados por recompensas',
    use: 'Usar',
    expired: 'Expirada'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'Fecha de vencimiento',
    expirationDelayExplain:
      'La recompensa será utilizable durante <span class="weglot-ignore">{expiration_delay}</span> días una vez que la haya canjeado.',
    minimumBuy: 'Compra mínima',
    maxAmount: 'Válido hasta',
    description: 'Descripción',
    saleChannel: 'Canal de venta',
    channelStore: 'En tienda',
    channelOnline: 'En línea',
    channelBoth: 'En línea y en tienda'
  },
  SectionRewardsDetailModal: {
    exchange: 'Canjear',
    errorMessage1: 'Parece que ha ocurrido un problema.',
    errorMessage2: 'Su recompensa no ha sido intercambiada y sus puntos no han sido deducidos.',
    errorMessage3: 'Por favor, recargue la página.',
    errorButton: 'Recargar la página'
  },
  SectionRewardsClaimModal: {
    howItWorks: '¿Cómo funciona?',
    howItWorkCode: 'Use su código en nuestro sitio web al realizar su pedido',
    howItWorkCodePOS: 'Presenta su código directamente en tienda al momento de pagar.',
    howItWorkCodeCMSPOS:
      'Use su código en nuestro sitio al realizar su pedido, o preséntelo directamente en la tienda al momento de pagar.',
    howItWorkCodeProduct: 'Agregue el producto a su carrito y luego use su código al realizar su pedido',
    howItWorkCodeRecharge: 'Agregue el código directamente en su portal de cliente',
    howItWorkExt: 'Será contactado para recibir su recompensa',
    applyToBasket: 'Aplicar al carrito',
    apply: 'Aplicar',
    applied: 'Aplicado',
    link: 'Enlace al producto',
    copied: '¡Copiado!',
    customerPortal: 'Portal de cliente',
    nonApplicable: 'No elegible'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'Aplicar',
    nonApplicable: 'No elegible',
    itemTitle: '{title} / {price}',
    customerPortal: 'Portal de cliente'
  },
  SectionReferral: {
    friendEmail: 'Correo electrónico de su amigo',
    seeReferral: 'Ver mis referencias',
    Tabs: {
      link: 'Enlace',
      email: 'Correo electrónico',
      sms: 'SMS',
      copy: 'Copiar enlace',
      smsSend: 'Enviar un mensaje',
      reward1: '{amount} puntos',
      reward2: '{amount}% de descuento',
      reward3: '{amount} vale',
      smsTemplate:
        '¡Hola! He descubierto {brand_name} que podría gustarte.\n\n Usando mi enlace de recomendación {referral_link}, te beneficiarás de {reward_friend}.\n\n¡Aprovéchalo, es una oferta realmente interesante!\n¡Hasta pronto!'
    },
    errors: {
      emailSelf: 'El correo electrónico ingresado es el mismo que su correo electrónico'
    },
    Modal: {
      emptyState: 'Aún no ha realizado ninguna referencia',
      title: 'Mis referencias',
      status: 'Estado',
      email: 'Correo electrónico',
      date: 'Fecha de vencimiento',
      statusPending: 'Pendiente',
      statusUsed: 'Ya usado',
      statusAvailable: 'Disponible',
      statusExpired: 'Expirado',
      statusInvalidate: 'Invalidado',
      promocodeComing: 'Próximamente',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'Invalidado',
      points_given: 'Sus puntos han sido acreditados',
      referral_type_3: 'Vale',
      referral_type_2: 'Código promocional',
      referral_type_1: 'Puntos'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'Correo electrónico',
      emailError: 'El formato del correo electrónico no es correcto',
      emailEmpty: 'Por favor, complete este campo',
      emailUnknown: 'Por favor, cree una cuenta para poder referir'
    }
  },
  SectionVipTiersProgress: {
    you: 'Tú',
    points: 'puntos'
  },
  SectionVipTiersCard: {
    rewardPoints: '{points} puntos de bonificación',
    rewardMultiplier: 'Multiplicador de puntos: x{multiplier}',

    tiersPoints: '{amount} puntos'
  },
  SectionGifting: {
    empty: 'No hay pruebas de productos disponibles en este momento',
    showAll: 'Mostrar todo',
    ModalApply: {
      endDate: 'Fecha de finalización de las aplicaciones',
      description: 'Descripción',
      completeForm: 'Complete el formulario para enviar su solicitud',
      button: 'Aplicar',
      success: {
        title: 'Registro de prueba de producto',
        description:
          'Gracias por completar su información. Su solicitud está siendo revisada. Será notificado por correo electrónico.'
      },
      Form: {
        Errors: {
          required: 'Por favor, complete este campo',
          date: 'Por favor, ingrese una fecha válida'
        }
      }
    },
    ModalParticipate: {
      challenges: 'Misiones',
      howItWorks: '¿Cómo funciona?',
      useCode: 'Use su código en nuestro sitio web al realizar su pedido.',
      youWillBeContacted: 'Será contactado para recibir su producto.',
      buttonLink: 'Enlace al producto',
      buttonCopied: '¡Copiado!'
    }
  },
  SectionGiftingCardList: {
    status: {
      participate: 'Participar',
      underValidation: 'En validación',
      apply: 'Aplicar',
      ended: 'Finalizado',
      rejected: 'Solicitud no aceptada'
    }
  },
  SectionSteps: {
    Authenticated: {
      month: '{n} mes| {n} meses'
    },
    ModalActivities: {
      title: 'Mis actividades recientes',
      empty: 'Aún no tiene actividades recientes.',
      table: {
        header: {
          title: 'Título',
          points: 'Puntos',
          date: 'Fecha'
        }
      },
      events: {
        challenge: 'Misión validada',
        order: 'Compra realizada',
        reward: 'Recompensa obtenida',
        refferal: 'Referencia validada',
        userAction: 'Puntos ajustados',
        level: 'Nivel alcanzado',
        levelLabel: 'Nivel {level}',
        reset: 'Expiración de los puntos',
        automation: 'Puntos ganados'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'Conectar a mi cuenta de TikTok',
      subtitle: 'Cómo funciona',
      description:
        'Por favor, ingrese su cuenta de TikTok y asegúrese de que sea pública. Luego podrá completar misiones de TikTok.',
      button: 'Vincular mi cuenta'
    },
    ModalLinked: {
      title: 'Conectar a mi cuenta de TikTok',
      subtitle: 'Conexión con su cuenta exitosa',
      congratulations: 'Felicitaciones',
      description: 'Ahora puede realizar misiones.',
      buttons: {
        edit: 'Editar mi cuenta',
        goback: 'Volver a la página'
      }
    }
  },
  SectionReferralFriend: {
    placeholder: 'Dirección de correo electrónico',
    emailError: 'Por favor, introduce una dirección de correo electrónico válida',
    emailEmpty: 'Por favor, introduce tu dirección de correo electrónico',
    disclaimer: 'Esta oferta es válida solo para nuevos clientes',
    disclaimerVerification: 'No serás contactado con fines comerciales.',
    referral_type_3: 'Vale de compra',
    referral_type_2: 'Código promocional',
    referral_type_1: 'Puntos',
    copied: '¡Copiado!',
    label_optin_reminder: 'Quiero recibir un recordatorio si no utilizo mi descuento.',
    btn_optin_reminder: 'Recibir un recordatorio de mi código'
  },
  Unsubscribe: {
    title: '¿Realmente deseas darte de baja de los correos electrónicos de nuestro programa de fidelidad?',
    description: 'Si es así, ten en cuenta que ya no recibirás información sobre tus recompensas, misiones y puntos.',
    email: 'Correo electrónico',
    button: 'Actualizar mis preferencias',
    question: '¿Qué tipo de correos electrónicos deseas recibir?',
    optinTransactional: 'Promocional: información sobre el programa, niveles VIP, recompensas.',
    optinMarketing: 'Información sobre compras y patrocinios.',
    successTitle: 'Tus preferencias han sido actualizadas',
    successDescription: 'Usa el botón de abajo para revisar o modificar tus preferencias',
    successButton: 'Actualizar mis preferencias',
    errorTitle: 'Hay un error con el enlace de redirección',
    errorButton: 'Redirigir al sitio web'
  },
  SectionAccount: {
    copied: '¡Copiado!'
  },
  SectionPointCard: {
    you: 'Tú',
    copied: '¡Copiado!'
  }
}
